import React from 'react';

const toneClasses = {
  grey: 'bg-neutral-100 text-neutral-700 ring-neutral-500/15 dark:bg-neutral-800 dark:text-neutral-300',
  green: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20 dark:bg-emerald-500/10 dark:text-emerald-300',
  amber: 'bg-amber-50 text-amber-800 ring-amber-600/25 dark:bg-amber-500/10 dark:text-amber-300',
  red: 'bg-red-50 text-red-700 ring-red-600/20 dark:bg-red-500/10 dark:text-red-300',
  brand: 'bg-brand-50 text-brand-700 ring-brand-500/25 dark:bg-brand-500/10 dark:text-brand-300',
  blue: 'bg-blue-50 text-blue-700 ring-blue-600/20 dark:bg-blue-500/10 dark:text-blue-300',
};

/**
 * Picks the badge colour for a status label shown in a list (Active, Fee Due, Blocked…).
 * The label itself is always shown, so status is never told by colour alone.
 */
export const toneForStatus = (statusLabel = '') => {
  const label = statusLabel.toLowerCase();
  if (['active', 'present', 'paid', 'completed', 'success', 'generated', 'approved'].includes(label)) {
    return 'green';
  }
  if (['fee due', 'on leave', 'pending', 'processing', 'in progress', 'partial', 'draft'].includes(label)) {
    return 'amber';
  }
  if (['dismissed', 'blocked', 'absent', 'failed', 'error', 'overdue', 'unpaid'].includes(label)) {
    return 'red';
  }
  return 'grey';
};

/**
 * Small coloured label for a status or a count.
 */
const Badge = ({ tone = 'grey', className = '', children }) => {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-xs font-medium whitespace-nowrap ring-1 ring-inset ${toneClasses[tone] || toneClasses.grey} ${className}`}
    >
      {children}
    </span>
  );
};

export default Badge;
